<template>
	<div id="recharge" class="page">
		<!-- 头部 -->
		<v-header :selectedItemVal="5" ref="header" style="background:white"></v-header>
		
		<div class="main">
			<div class="recharge_header">  
				<div class="r_header_left">
					<div class="account_logo">
						<a class="left" href="javascript:;">
							<img :src="photoFiled" v-if="photoFiled != ''" width="80" height="80" alt="" />
							<img src="../../assets/img/logo.png" v-else alt="">
						</a>
					</div>
					<div class="account_msg">
						<p>
							账号：
							<span class="account_name">{{ nickName }}</span>
						</p>
						<p style="display: inline-flex;">
							当前账户：
							<span class="account_money">{{ myWallet }}</span>
							<span class="account_money_currency">
								<img src="../../assets/img/recharge/牛币.png" alt="">
							</span>
						</p>
					</div>

				</div>
				<div class="r_header_right"></div>
			</div>
			<div class="recharge_main">
				<div class="r_main_content">
					<div class="r_content r_content_1">
						<el-row>
							<el-col :span="12">
								应收：
								<span class="r_content_1_money">{{ activeRechargeItem.grMoney }}元</span>
							</el-col>
							<!-- <el-col :span="8">
								优惠：
								<span class="r_content_1_money">{{ activeRechargeItem.grDiscountNum }}元</span>
							</el-col> -->
							<el-col :span="12">
								实收：
								<span class="r_content_1_money">{{ activeRechargeItem.shiShou }}元</span>
							</el-col>
						</el-row>
						
					</div>
					<div class="r_content r_content_2">
						<div class="money_choose">
							<div class="m_choose_box" v-for="(item,index) in moneyChooseList" :key="index" @click="chooseMoney(item)">
								<el-card :class="{money_selected:item.grId==moneySelectedId}">
									<span>{{item.niubi}}</span>
									<span>
										<img src="../../assets/img/recharge/牛币.png" alt="">
									</span>
								</el-card>
							</div>
						</div>
					</div>
					<div class="r_content r_content_3">
						<div class="paytype_desc">支付方式：</div>
						<div class="pay_type">
							<div class="pay third_part wx_pay third_part_wx" :class="{wx_pay_selected:payTypeSelectedId == 1}" @click="choosePayType(1)">
								<img src="../../assets/img/recharge/arrow_icon.png" alt="" style="position: relative;left: 176px;top: 43px;" v-if="payTypeSelectedId == 1">
							</div>
							<div class="pay third_part ali_pay third_part_ali" :class="{ali_pay_selected:payTypeSelectedId == 2}" @click="choosePayType(2)">
								<img src="../../assets/img/recharge/arrow_icon.png" alt="" style="position: relative;left: 176px;top: 43px;" v-if="payTypeSelectedId == 2">
							</div>
						</div>
					</div>
					<div class="r_content r_content_4">
						<div class="pay" @click="paySubmit()">
							<el-button type="primary">确认支付</el-button>
						</div>
						<div class="pay_agreement">
							<div>
								<span class="agreementBtn" @click="agreeRechargeAgreement()">
									<input type="radio" name="agreeRecharge" :checked="radioSelected">
									已阅读并同意
								</span>
								<a href="javascript:;" @click="isAgreementShow = true">《充值协议》</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-dialog title="充值页面"
				:visible.sync="rechargeCodeDialog"
				:close-on-click-modal="false"
				width="30%" @close="rechargeCodeDialogClose">
					<div class="rechargeCodeDialog" style="text-align: center;">
						<div class="min-header">
							<div class="midcon text-right">
								欢迎使用三方支付！
							</div>
						</div>
						<div class="midcon">
							<h4>正在使用三方即时到账交易<span class="money">充值金额：<span class="mval">{{ activeRechargeItem.shiShou}}</span>元</span></h4>
							<div class="qrbox">
								<img alt="支付二维码" :src="payQrCode" style="width:150px;height:150px;"/>
								<!-- <div class="bdes">使用微信扫码支付</div> -->
							</div>
						</div>
					</div>
			</el-dialog>
			<el-dialog 
			:visible.sync="isAgreementShow"
			:close-on-click-modal="false">
					<v-agreement></v-agreement>
			</el-dialog>
			<div class="recharge_footer">
				<img src="../../assets/img/recharge/充值规则.png" alt="">
				
				<div class="r_footer_content">
					<p>1、充值所得金牛可在斗牛APP及斗牛官网消费</p>
					<p>2、优惠券直接抵扣实付现金，充值后购买金股池无需使用优惠券</p>
				</div>
			</div>
		</div>
		
		<v-footer></v-footer>
	</div>
</template>

<script>
import vHeader from '../common/header'

import vFooter from '../common/footer'
import vAgreement from './agreement'
export default {
	components: {
      'v-header': vHeader,
	  'v-footer':vFooter,
	  'v-agreement': vAgreement
    },
	data(){
		return{
			//+------------用户相关信息
			nickName:'',
			myWallet:'',
			photoFiled:'',
			recommendText:'',
			customerService:'',
			//+-----------充值相关信息
			isAgreementShow: false,
			radioSelected:0,
			moneySelectedId:0,
			payTypeSelectedId:1,
			//支付方式0牛币 1微信 2支付宝 3积分 4其他
			payType:1,
			activeRechargeItem:[],
			moneyChooseList:[],
			rechargeOrder:{
				orderId:0,
				orderNo:0,
			},
			rechargeCodeDialog:false,
			payQrCode:'',
			checkPayTimer:'',
		}
	},
	created() {
		
	},
	mounted:function(){
		//获取渲染页面所需数据
		this.getPayPage();
	},
	methods:{
		//第一步 获取充值信息
		getPayPage(){
			//+-------------------构建请求参数--------------------------
			let data = {
				applicationType:this.store.state.applicationType
			}
			//+--------------------请求充值信息------------------------
			this.apiServer.payment.payInfo(data)
			.then(res => {
				if(res.data.code == 200){
					if(res.data.data.businessCode != 10){
						this.$message.error('充值页面渲染异常');
						return false;
					}
					
					//更新渲染数据
					this.nickName = res.data.data.nickName;
					this.photoFiled = res.data.data.photoFiled;
					this.myWallet = res.data.data.myWallet;
					this.customerService = res.data.data.customerService;
					this.moneyChooseList = res.data.data.iosGoldRewardList;
					
					//更新当前选中数据
					this.activeRechargeItem = this.moneyChooseList[0];
					this.moneySelectedId = this.activeRechargeItem.grId;
				}
			})
			.catch(res => {
				this.$message.error('充值页面渲染数据异常');
			})
		},
		chooseMoney(item){
			//更新选中
			this.moneySelectedId = item.grId
			// 获取下标对应充值内容
			this.activeRechargeItem = item;
		},
		choosePayType(index){
			//更新支付方式下标
			this.payTypeSelectedId = index;
			//更新支付类型
			this.payType = index;
		},
		agreeRechargeAgreement(e){
			this.radioSelected = !this.radioSelected;
		},
		//确认充值
		confirmPay(){
			let data = {
				grId:this.rechargeOrder.orderId,
				payType:2,
				payChannel:this.payType == 1 ? 'wechat' : 'alipay',
			};
			this.apiServer.payment.confirmRechargePay(data.payChannel,this.qs.stringify(data))
			.then(res => {
				if(res.data.code == 200){
					if(res.data.data.code == 20){
						this.$message.error('订单无效');
						return false;
					}
					
					if(res.data.data.code == 30){
						this.$message.error('三方下单失败');
						return false;
					}
					//微信充值
					if(this.payType == 1){
						this.payQrCode = "data:image/png;base64," + res.data.data.wechatResult.base64Img;
					}
					//支付宝充值
					if(this.payType == 2){
						this.payQrCode = "data:image/png;base64," + res.data.data.aliPayResult.base64Img;
					}
					
					//充值扫码页显示
					this.rechargeCodeDialog = true;
					
					//定时检查支付状态
					this.checkPayTimer = setInterval(() => this.checkRechargePayStatus(),1000);
				}
			})
			.catch(res => {
				this.$message.error('确认充值请求异常');
			})
		},
		//点击充值
		paySubmit(){
			// console.log('点击提交支付');
			// console.log('--------------------支付数据---------------------');
			// console.log(this.rechargeData);
			//+-----------------------必须同意协议-------------------------
			if(this.radioSelected != 1){
				this.$message.error('请阅读并同意《充值协议》后操作');return false;
			}
			//+-------------------------充值流程---------------------------
			//1 创建充值 2 确认支付 3检查状态
			//+-----------------构建请求参数------------------------------
			let data = {
				grId:this.activeRechargeItem.grId,
				payType:this.payType,
			};
			//创建订单
			this.apiServer.payment.createOrder(this.qs.stringify(data))
			.then(res => {
				if(res.data.code == 200){
					if(res.data.data.businessCode != 10){
						this.$message.error('充值订单创建异常');
						return false;
					}
					//更新充值订单数据（订单id，订单号）
					this.rechargeOrder.orderId = res.data.data.orderId;
					this.rechargeOrder.orderNo = res.data.data.orderNo;
					
					//确认支付
					this.confirmPay();
				}
			})
			.catch(res => {
				this.$message.error('创建充值订单异常');
			});
		},
		//检查三方充值支付状态
		checkRechargePayStatus(){
			//+---------------------构建请求参数-------------------
			let data = {
				orderId:this.rechargeOrder.orderId,
			};
			//+--------------------获取支付状态-------------------
			this.apiServer.payment.checkPayStatus(data)
			.then(res => {
				if(res.data.code == 200){
					if(res.data.data.code != 10){
						this.$message.error('参数无效');
						return false;
					}
					// console.log('-----支付状态------');
					// console.log(res.data.data);
					
					//未成功
					if(!res.data.data.payStatus){
						return false;
					}
					
					//支付成功，充值dialog关闭，清除定时器
					this.rechargeCodeDialog = false;
					clearInterval(this.checkPayTimer);
				}
			})
			.catch(res => {
				
			});
		},
		//充值dialog关闭
		rechargeCodeDialogClose(){
			//关闭清除定时器
			clearInterval(this.checkPayTimer);
			this.checkPayTimer = null;
		}
	}
}
</script>

<style scoped>

	.r_header_left a.left{ 
		  float:left;
	}
	#yz{ 
		margin-left:90px;
	}
	.main{
		width: 1250px;
		height: 100%;
	}
	
	.recharge_header{
		height: 150px;
		background: url(../../assets/img/recharge/recharge_bg.png) no-repeat fixed center;
		background-size: cover;
		display: flex;
	}
	
	.r_header_left{
		
		width: 90%;
		margin: 0 auto;
		display: flex;
		align-items: center;
	}
	
	.r_header_right{
	}
	
	.r_header_left .account_logo{
		padding: 5%;
	}
	
	.account_logo img{
		border-radius: 50%;
	}
	
	.r_header_left .account_msg{
		padding: 0;
		color: #FFFFFF;
		font-size: 1.5rem;
		/* text-align: center; */
	}
	
	.account_msg .account_money{
		font-size:2.25rem
	}
	
	.recharge_main{
		background-color: #FFFFFF;
	}
	
	.r_main_content .r_content{
		
	}
	
	.r_content_1{
		font-size: 24px;
		font-family: PingFangSC-Regular, PingFang SC;
		color: #666666;
		line-height: 5rem;
		text-align: center;
	}
	
	.r_content_1 .r_content_1_money{
		
		font-size: 1.5rem;
		font-family: PingFangSC-Semibold, PingFang SC;
		color: #C60B09;
	}
	
	.r_content_2 .money_choose{
		width: 90%;
		margin: 0 auto;
	}
	
	.r_content_2 .el-card{
		width: 198px;
		margin: 0.5rem auto;
		position:relative;
		cursor: pointer;
		text-align: center;
	}
	
	.r_content_2 .m_choose_box span:nth-child(1){
		position: relative;
		font-size: 30px;
	}
	
	
	.r_content_2 .m_choose_box img{
		position: relative;
		top: 5px;
	}
	
	.r_content_3{
		width: 80%;
		height: 6.25rem;
		margin: 0 auto;
		display: flex;
		align-items: center;
	}
	
	.paytype_desc{
		width: 20%;
		height: 33px;
		font-size: 24px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #222222;
		line-height: 33px;
	}
	
	.pay_type{
		width: 80%;
		display: flex;
		justify-content: space-around;
	}
	
	
	.pay_type .wx_pay{
		background: url(../../assets/img/pay/微信未选中.png) no-repeat center;
		background-size: cover;
	}
	.pay_type .wx_pay_selected{
		background: url(../../assets/img/pay/微信选中.png) no-repeat center;
		background-size: cover;
	}
	
	.pay_type .ali_pay{
		background: url(../../assets/img/pay/支付宝未选中.png) no-repeat center;
		background-size: cover;
	}
	.pay_type .ali_pay_selected{
		background: url(../../assets/img/pay/支付宝选中.png) no-repeat center;
		background-size: cover;
	}
	
	.r_content_3 .pay_type .pay{
		font-size: 1.5rem;
	}
	
	.r_content_3 .pay_type .third_part{
		width: 198px;
		height: 68px;
		cursor: pointer;
	}
	
	.m_choose_box{
		width: 25%;
		display: inline-block;
	}

	.r_content_4{
		width: 100%;
		line-height: 3.25rem;
		text-align: center;
	}
	
	.r_content_4 .el-button{
		width: 12.5rem;
		height: 3.125rem;
	}
	
	.r_content_4 .pay_agreement .el-radio{
		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
	}
	
	.r_content_4 .pay_agreement a{
		color: #5aa8ff;
		text-decoration: none;
	}
	
	.money_selected{
		background: url(../../assets/img/recharge/selected_bg_2x.png) no-repeat fixed center;
		background-size: cover;
		color:#FFFFFF;
	}
	
	
	.recharge_footer{
		height: 274px;
		background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
		border-radius: 12px;
		position: relative;
		
		margin-top: 83px;
		text-align: left;
	}
	.agreementBtn{
		cursor: pointer;
	}
	.recharge_footer img{
		right: 27%;
		position: absolute;
		top: -30%;
		width: 50%;
		height: 50%;
	}
	
	.r_footer_content{
		position: absolute;
		margin: 5% 20% 5% 20%;
		
	}
	
	.el-dialog__header{
		padding: 0;
	}
	.el-dialog__body{
		padding: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/recharge/recharge.vue